import * as angular from 'angular';
import * as d3 from 'd3';

import { IRequestService } from '../request.service';
import { Alias, Group, IdentifierType } from '../../models';

export interface ImportedGroup {
    guid: string;
    name: string;
    longComment: string;
    type: string;
    children: ImportedGroup[];
    Identifiers: ImportedIdentifier[];
    Parameters: ImportedParameter[];
    fullPath: string;
    importedId: string;
    parentId: string;
    objectType: string;
}

export interface ImportedIdentifier {
    guid: string;
    name: string;
    identifierType: IdentifierType;
    tagName: string;
    unit: string;
    longComment: string;
}

export interface ImportedParameter {
    guid: string;
    name: string;
    unit: string;
    value: number;
}

export interface IGroupsImportService {
    checkNumberOftags(group: ImportedGroup): angular.IPromise<boolean[]>;
    find(namePattern: string, cpGuid: string): angular.IPromise<d3.layout.hierarchy.Result[][]>;
    findUnkown(group: ImportedGroup): angular.IPromise<string[]>;
    import(group: ImportedGroup, rootGuid: string, connectionpointGuid: string, extraAliases: Alias[]): angular.
        IPromise<Group[]>;
}

export class GroupsImportService implements IGroupsImportService {
    static serviceId: string = 'GroupsImportService';

    static $inject = ['requestService'];
    constructor(private _requestService: IRequestService) {
    }

    find(namePattern: string, cpGuid: string): angular.IPromise<d3.layout.hierarchy.Result[][]> {
        const url = 'importGroups/search';
        const params = {
            connectionPointGuid: cpGuid,
            namePattern: namePattern
        };
        const layout = d3.layout.hierarchy();
        return this._requestService
            .postAtV1<ImportedGroup[]>(url, params)
            .then(data => {
                const mapped = data.map(d => {
                    const laidOut = layout(d);
                    laidOut.forEach(l => l.parent = null);
                    return laidOut;
                });
                return mapped;
            });
    }

    import(group: ImportedGroup, rootGuid: string, connectionpointGuid: string, extraAliases: Alias[]): angular.IPromise<Group[]> {
        return this._requestService
            .postAtV1<Group[]>('importGroups/import',
                {
                    group: group,
                    rootGuid: rootGuid,
                    connectionPointGuid: connectionpointGuid,
                    extraAliases: extraAliases
                })
            .then(data => {
                this._requestService.cleanCacheAtV1('group/');
                this._requestService.cleanCacheAtV1('tagDefinition/');
                this._requestService.cleanCacheAtV1('template/changes/all');
                this._requestService.cleanCacheAtV1('viewModel/all');
                return data;
            });
    }

    findUnkown(group: ImportedGroup): angular.IPromise<string[]> {
        return this._requestService.postAtV1('importGroups/findUnkown', group);
    }
    checkNumberOftags(group: ImportedGroup): angular.IPromise<boolean[]> {
        return this._requestService.postAtV1('importGroups/checkNumberOftags', group);
    }

}